import type { SearchAmbassador } from '@bulknutrients/bulk-shared-lib/interfaces/Ambassador';
import { CustomImage } from '@components/Media/Image';
import { Paragraph } from '@components/Typography/Paragraph/Paragraph';
import { TextLink } from '@components/Typography/TextLink/TextLink';
import Link from 'next/link';
import type { ReactElement } from 'react';

export function SearchResultCardAmbassador({
  hit,
}: {
  hit: SearchAmbassador;
}): ReactElement {
  if (!hit.slug) {
    return <></>;
  }
  return (
    <div className="card flex flex-col dark:bg-grey-dark overflow-hidden rounded-2xl transition-all duration-300 hover:scale-103">
      <Link
        prefetch={process.env.NEXT_PUBLIC_PREFETCH === 'true'}
        href={hit.slug}
        data-umami-event="hue-link-click"
        data-umami-event-slug={hit.slug}
        data-umami-event-location="Search Result Ambassador Card Image"
      >
        <CustomImage
          image={hit.thumbnail}
          width={400}
          height={400}
          className="rounded-none"
        />
      </Link>
      <div className="p-4">
        <TextLink
          href={hit.slug}
          data-umami-event-location="Search Result Ambassador Card Heading"
        >
          <h2 className="font-secondary text-2xl uppercase">{hit.name}</h2>
        </TextLink>
        <Paragraph className="m-0 text-sm mt-4">
          {hit.shortDescription}
        </Paragraph>
      </div>
    </div>
  );
}
